import logo from 'media/logo.png'

const Logo: React.FC = () => {
  return (
    <div className="mainLogo">
      <img src={logo} />
      <p>Telcel Puntos</p>
    </div>
  )
}

export default Logo
